module.exports = __webpack_public_path__ + "static/girls-e814a3541f0fcf20432bf15f6354be10.jpg";